import React from "react";
import ReactDOM from "react-dom";
import AppProvider from "Providers/AppProvider";
import { color } from "Configs/theme";
import { hackShadowRoot } from "Helpers/ShadowRootHelper";
import { isDesktopSafari } from "Helpers/PlatformHelper";
import { initDeveloperMountingTools } from "Helpers/initDeveloperMountingTools";
import { devLog } from "utils/developmentLogger";

export default class PlanningBoard extends HTMLElement {
	mountPoint: HTMLDivElement;
	isStandaloneApp: boolean;
	userToken: string | null;
	initialDate: string | null;
	initialView: string | null;
	private _shadowRoot: ShadowRoot | null = null;
	reactRoot: HTMLDivElement | null = null;

	static get observedAttributes() {
		return ['user-token', 'initial-date', 'initial-view'];
	}

	constructor() {
		super();
		const isStandaloneApp = this.hasAttribute("is-standalone-app");

		this.mountPoint = document.createElement("div");
		this.mountPoint.style.display =
			isDesktopSafari() && !isStandaloneApp ? "block" : "flex";
		this.mountPoint.style.flex = "1";
		this.mountPoint.style.backgroundColor = color.totalBackground;
		this.mountPoint.style.overflowX = "hidden";
		this.isStandaloneApp = isStandaloneApp;
		this.userToken = this.getAttribute("user-token");
		this.initialDate = this.getAttribute("initial-date");
		this.initialView = this.getAttribute("initial-view");

		if (!this.isStandaloneApp) {
			this.mountPoint.style.overflowY = "scroll";
		}
	}

	connectedCallback() {
		this._shadowRoot = this.attachShadow({ mode: "open" });
		this.reactRoot = this._shadowRoot.appendChild(this.mountPoint);
		this.updateAttributes();
		this.renderApp();
	}

	attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null) {
		if (oldValue !== newValue && this._shadowRoot && this.reactRoot) {
			devLog.log(`[PlanningBoard] Attribute ${name} changed from ${oldValue} to ${newValue}`);
			this.updateAttributes();
			this.renderApp();
		}
	}

	private updateAttributes() {
		this.userToken = this.getAttribute("user-token");
		this.initialDate = this.getAttribute("initial-date");
		this.initialView = this.getAttribute("initial-view");
	}

	private renderApp() {
		if (!this._shadowRoot || !this.reactRoot) return;

		hackShadowRoot(this.mountPoint, this._shadowRoot);
		ReactDOM.render(
			<AppProvider
				shadowRoot={this._shadowRoot}
				reactRoot={this.reactRoot}
				mountPoint={this.mountPoint}
				isStandaloneApp={this.isStandaloneApp}
				token={this.userToken}
				initialDate={this.initialDate}
				initialView={this.initialView}
			/>,
			this.mountPoint
		);
	}

	disconnectedCallback() {
		if (this.mountPoint) {
			ReactDOM.unmountComponentAtNode(this.mountPoint);
		}
	}
}

export const CUSTOM_ELEMENT_NAME = "planning-board";

window.customElements.define(CUSTOM_ELEMENT_NAME, PlanningBoard);

if (window.location.hostname === "localhost") {
	initDeveloperMountingTools();
}
